module.exports = __webpack_public_path__ + "img/preview-12.59807f81.jpg";